import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";




@Injectable({
    providedIn: 'root'
})
export class GlCategoryFileHelperService extends BaseApiTemplateService<any> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-category/import-file-hdr/helper'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-category/import-file-hdr/helper';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gl-category/import-file-hdr/helper';
        this.httpClient = http;
    }

}

